import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class PlatformService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  addWindowsClass(): void {
    if (navigator.userAgent.includes("Windows")) {
      this.document.body.classList.add("windows-os");
    }
  }
}
